import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { useBreakpoints } from 'hooks';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { TeamSectionDesktop, TeamSectionMobile } from './components';

import styles from './TeamSection.module.scss';

export const TeamSection: React.FC = () => {
  const { data } = useDataContext();
  const { isMobile } = useBreakpoints();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.team);

  const { teamMembers, team } = data;

  if (!hasMeaningfulValues({ teamMembers, team }) || !teamMembers) {
    return null;
  }

  return (
    <Box {...registerNavSection} className={styles.section}>
      <Box className={styles.wrapper}>
        <Box className={styles.title}>{t('chapters.TEAM')}</Box>

        {team && <Box className={styles.label}>{team}</Box>}

        {isMobile ? <TeamSectionMobile /> : <TeamSectionDesktop />}
      </Box>
    </Box>
  );
};
